var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBronzeFrame = function SvgBronzeFrame(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 64,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#bronzeFrame_svg__a)",
    fillRule: "evenodd",
    d: "M33.71.676a3 3 0 0 0-3 0L5.998 14.944a3 3 0 0 0-1.5 2.597v28.536a3 3 0 0 0 1.5 2.599L30.71 62.942a3 3 0 0 0 3 0l24.713-14.267a3 3 0 0 0 1.5-2.599V17.542a3 3 0 0 0-1.5-2.599zm0 6.357a3 3 0 0 0-3 0l-19.207 11.09a3 3 0 0 0-1.5 2.597V42.9a3 3 0 0 0 1.5 2.598L30.71 56.586a3 3 0 0 0 3 0l19.207-11.09a3 3 0 0 0 1.5-2.597V20.72a3 3 0 0 0-1.5-2.598z",
    clipRule: "evenodd"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "bronzeFrame_svg__a",
    x1: 32.21,
    x2: 32.21,
    y1: 63.809,
    y2: -0.191,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#832A06"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ED9F84"
  })))));
};
export default SvgBronzeFrame;